import { is } from 'ramda'

export default {
  /**
   * Sets the local modal values into the state.
   *
   * @param {Object} state
   * @param {Object} payload
   * @constructor
   */
  SET_VALUES(state, payload) {
    state.targetElement = payload.targetElement || null
    state.contentComponent = payload.contentComponent || null
    state.maskComponent = payload.maskComponent || null
    state.attachment = payload.attachment || null
    state.targetAttachment = payload.targetAttachment || state.targetAttachment
    state.colour = payload.colour || state.colour
    state.width = payload.width || null
    state.componentData = payload.componentData || state.componentData
    state.customClass = is(String, payload.customClass) ? payload.customClass : state.customClass
  },
}
